import "./theme.css"
import { useTheme } from "../context/ThemeContext";
import AvatarSystem from "./avatar-system/AvatarSystem";

export default function Avatar() {
  const {theme} = useTheme();
  return (
    <main className={`avatar-scope min-h-screen ${theme==="dark" ? "bg-slate-900" : "bg-slate-100"} to-slate-900 ${theme} `}>
      <AvatarSystem />
    </main>
  )
}
